import React from "react";
import {Ul} from "BaseComponents/List/List";
import {H2} from "BaseComponents/Text";
import {IconButton} from "BaseComponents/Button";
import {
    ButtonWrapper,
    Department,
    FooterBottom,
    FooterBottomReportBlock,
    FooterColumn,
    FooterTop,
    Grid,
    H3,
    Info,
    SocialMediaColumn,
    Wrapper
} from "./";
import {useGlobal} from "reactn";
import {RTEWrapper} from "BaseComponents/Wrappers";
import {footerTextClass} from "Helpers/ColorHelper";
import LazyImage from "../../framework/lazy/LazyImage";

export const Footer = (footer) => {
    const {
        AltText,
        PhoneButtonLabel,
        LogoUrl,
        LogoSrc,
        EmailAddress,
        EmailButtonLabel,
        FacebookLink,
        TikTokLink,
        FirstColumnHeading,
        ZipCode,
        Adress,
        FooterColumnLogoLink,
        ContactHeading,
        ContactText,
        ContactPhone,
        ContactPhoneString,
        SecondColumnHeading,
        Departments,
        FooterColumns,
        InstagramLink,
        LinkedInLink,
        LrkNumber,
        LrkNumberString,
        YoutubeLink,
        PhoneNumber,
        SocialMediaHeading,
        TwitterLink,
        CompanyName,
        ShowFindUs,
        FindUs,
        PlaceSocialLinksAtTheBottom,
        ReportTechnicalIssuePage,
        FooterDescriptionUnderLogo
    } = footer;

    const [theme] = useGlobal("theme");
    const buttons = () => {
        return (
            <ButtonWrapper
                className="footer_actionBtns"
                alignItems={"flex-start"}
                margin="0"
            >
                {PhoneNumber.length > 0 && (
                    <IconButton
                        innerClassName="footerContactItem"
                        label={PhoneButtonLabel}
                        inverted
                        borderColor="white"
                        href={`tel:${PhoneNumber}`}
                        icon="icon-phone-2"
                        width={"auto"}
                        minWidth="180px"
                        justifycontent={
                            currentTheme === "norlandiacare" ? "flex-start" : "center"
                        }
                        padding={currentTheme === "norlandiacare" ? "0" : undefined}
                    />
                )}
                {EmailAddress.length > 0 && (
                    <IconButton
                        innerClassName="footerContactItem"
                        inverted
                        forcedColor={
                            currentTheme === "norlandiacare" || currentTheme === "hero"
                                ? theme.colors.footerSpanColor
                                : undefined
                        }
                        borderColor="white"
                        label={EmailButtonLabel}
                        href={`mailto:${EmailAddress}`}
                        icon="icon-mail"
                        width={"auto"}
                        minWidth="180px"
                        justifycontent={
                            currentTheme === "norlandiacare" ? "flex-start" : "center"
                        }
                        padding={currentTheme === "norlandiacare" ? "0" : undefined}
                    />
                )}
                {ShowFindUs && (
                    <IconButton
                        innerClassName="footerContactItem"
                        target={FindUs.Target}
                        inverted
                        forcedColor={
                            currentTheme === "norlandiacare" || currentTheme === "hero"
                                ? theme.colors.footerSpanColor
                                : undefined
                        }
                        borderColor="white"
                        href={FindUs.Url}
                        icon="icon-marker-1"
                        label={FindUs.Name}
                        width={"auto"}
                        minWidth="180px"
                        justifycontent={
                            currentTheme === "norlandiacare" ? "flex-start" : "center"
                        }
                        padding={currentTheme === "norlandiacare" ? "0" : undefined}
                    />
                )}
            </ButtonWrapper>
        );
    };
    return (
        <Wrapper>
            <FooterTop rowGap={PlaceSocialLinksAtTheBottom ? "70px" : "0"}>
                <Grid useThree={PlaceSocialLinksAtTheBottom}>
                    {FirstColumnHeading && <H2 fontWeight="700">{FirstColumnHeading}</H2>}

                    <Info className="footerInfo_section">
                        {CompanyName.length > 0 && <p>{CompanyName}</p>}
                        {Adress != null && <p> {Adress}</p>}
                        {ZipCode.length > 0 && <p>{ZipCode.replace(/,/g, "")}</p>}
                    </Info>
                    <Info className="footerInfo_section">
                        {LrkNumber.length > 0 && (
                            <p>
                                {LrkNumberString}
                                {LrkNumber}
                            </p>
                        )}
                        {ContactHeading.length > 0 && currentTheme !== "norlandiacare" && (
                            <H3>{ContactHeading}</H3>
                        )}
                        {ContactText.length > 0 && <p>{ContactText}</p>}
                        {ContactPhone.length > 0 && currentTheme !== "norlandiacare" ? (
                            <a href={`tel:${ContactPhone}`}>
                                <span>{ContactPhoneString}</span>

                                <span>{ContactPhone}</span>
                            </a>
                        ) : (
                            ContactPhone.length > 0 && (
                                <p>
                                    <span>{ContactPhoneString}</span> <span>{ContactPhone}</span>
                                </p>
                            )
                        )}
                    </Info>
                    {(!PlaceSocialLinksAtTheBottom ||
                            PlaceSocialLinksAtTheBottom === "false") &&
                        buttons()}
                </Grid>
                {Departments.length > 0 && (
                    <Grid useThree={PlaceSocialLinksAtTheBottom}>
                        {SecondColumnHeading && <H2 fontWeight="700">{SecondColumnHeading}</H2>}
                        <Info className="footerInfo_section">
                            <Ul>
                                {Departments.map((dep, i) => {
                                    return (
                                        <Department key={`department-${i}`} {...dep}></Department>
                                    );
                                })}
                            </Ul>
                        </Info>
                    </Grid>
                )}
                {FooterColumns != undefined &&
                    FooterColumns.map((column, i) => {
                        return (
                            <FooterColumn
                                key={`footer-column-list-${i}`}
                                {...column}
                                useThree={PlaceSocialLinksAtTheBottom}
                            />
                        );
                    })}
                {(PlaceSocialLinksAtTheBottom ||
                    PlaceSocialLinksAtTheBottom === "true") && (
                    <Grid useThree={PlaceSocialLinksAtTheBottom}>{buttons()}</Grid>
                )}
                <SocialMediaColumn
                    useThree={PlaceSocialLinksAtTheBottom}
                    SocialMediaHeading={SocialMediaHeading}
                    facebook={FacebookLink}
                    instagram={InstagramLink}
                    twitter={TwitterLink}
                    linkedIn={LinkedInLink}
                    youtube={YoutubeLink}
                    tiktok={TikTokLink}
                />
            </FooterTop>
            <FooterBottom flexDirection={"row"} className="footerBottom_section">
                <FooterBottom marginTop={"0"} className="footerBottom_section">
                    <a className="footer__bottom__logo" href={LogoUrl} aria-label={AltText}>
                        <LazyImage source={LogoSrc} alt={AltText}/>
                    </a>
                    {FooterColumnLogoLink != undefined && (
                        <a
                            className={`element-link--footer logo-link ${footerTextClass(
                                theme.colors.footerGradient
                            )}`}
                            href={FooterColumnLogoLink.Url}
                            target={FooterColumnLogoLink.Target}
                            aria-label={AltText}
                        >
                <span className="element-link--footer--standard">
                  {FooterColumnLogoLink.Name}
                </span>
                        </a>
                    )}
                </FooterBottom>
                {ReportTechnicalIssuePage != undefined &&
                    <FooterBottomReportBlock>
                        <a className={`element-link--footer logo-link`}
                           href={ReportTechnicalIssuePage.Url}
                           target={ReportTechnicalIssuePage.Target}
                           aria-label={AltText}>
                            <i className="far fa-arrow-right-long" aria-hidden="true"/>
                            <span className="">
              {ReportTechnicalIssuePage.Name}
            </span>
                        </a>
                    </FooterBottomReportBlock>}
            </FooterBottom>
            {FooterDescriptionUnderLogo && <div dangerouslySetInnerHTML={{
                __html: FooterDescriptionUnderLogo
            }}></div>}
        </Wrapper>
    );
};
